const stats = [
  { label: "Total Balance", value: "₦569,842,150.75" },
  { label: "Today's Volume", value: "₦1,707,442,300" },
  { label: "Transactions", value: "12,842" },
  { label: "Success Rate", value: "99.8%", green: true },
];

const rows = [
  { id: "SW-28491", desc: "International Payout", amount: "12,500", ccy: "USD", status: "Completed" },
  { id: "SW-28490", desc: "Customer Collection", amount: "11,250,000", ccy: "NGN", status: "Completed" },
  { id: "SW-28489", desc: "FX Conversion", amount: "650,000", ccy: "KES", status: "Processing" },
  { id: "SW-28488", desc: "Bank Transfer", amount: "920,000", ccy: "ZAR", status: "Completed" },
];

const Badge = ({ status }) =>
  status === "Completed" ? (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-600">
      <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> Completed
    </span>
  ) : (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2.5 py-1 text-xs font-medium text-amber-600">
      <span className="h-1.5 w-1.5 rounded-full bg-amber-500" /> Processing
    </span>
  );

const VolumeChart = () => (
  <svg viewBox="0 0 560 160" className="h-full w-full" preserveAspectRatio="none" aria-hidden="true">
    <defs>
      <linearGradient id="vol" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#2E7CD6" stopOpacity="0.22" />
        <stop offset="1" stopColor="#2E7CD6" stopOpacity="0" />
      </linearGradient>
    </defs>
    {[32, 64, 96, 128].map((y) => (
      <line key={y} x1="0" y1={y} x2="560" y2={y} stroke="#EEF2F7" strokeWidth="1" />
    ))}
    <path
      d="M0 120 C40 112 70 128 110 104 C150 80 180 96 220 84 C260 72 290 88 330 60 C370 36 400 58 440 42 C480 28 520 36 560 22 L560 160 L0 160 Z"
      fill="url(#vol)"
    />
    <path
      d="M0 120 C40 112 70 128 110 104 C150 80 180 96 220 84 C260 72 290 88 330 60 C370 36 400 58 440 42 C480 28 520 36 560 22"
      fill="none"
      stroke="#2E7CD6"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="440" cy="42" r="4" fill="#fff" stroke="#2E7CD6" strokeWidth="2.5" />
  </svg>
);

const DashboardMockup = () => (
  <div data-testid="dashboard-mockup" className="overflow-hidden rounded-3xl border border-[#E2E8F0] bg-white shadow-2xl shadow-slate-900/[0.07]">
    {/* window chrome */}
    <div className="flex items-center gap-2 border-b border-[#E2E8F0] bg-[#F8FAFC] px-5 py-3.5">
      <span className="h-2.5 w-2.5 rounded-full bg-[#E2E8F0]" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#E2E8F0]" />
      <span className="h-2.5 w-2.5 rounded-full bg-[#E2E8F0]" />
      <span className="ml-3 rounded-md bg-white px-3 py-1 text-xs text-[#64748B] border border-[#E2E8F0]">app.swiftwire.com/overview</span>
    </div>

    <div className="p-5 sm:p-7">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-base font-bold text-[#0F172A]">Overview</h3>
        <span className="rounded-full bg-[#F1F5F9] px-3 py-1 text-xs font-medium text-[#64748B]">Last 30 days</span>
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border border-[#E2E8F0] bg-[#F8FAFC] p-4" data-testid={`stat-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <p className="text-xs text-[#64748B]">{s.label}</p>
            <p className={`mt-1.5 font-heading text-lg font-bold sm:text-xl ${s.green ? "text-emerald-600" : "text-[#0F172A]"}`}>{s.value}</p>
          </div>
        ))}
      </div>

      <div className="mt-5 grid gap-5 lg:grid-cols-[1fr_1.5fr]">
        <div className="rounded-xl border border-[#E2E8F0] p-4">
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold text-[#0F172A]">Transaction volume</p>
            <span className="text-xs font-medium text-emerald-600">+18.2%</span>
          </div>
          <div className="mt-3 h-[140px]">
            <VolumeChart />
          </div>
        </div>

        <div className="overflow-x-auto rounded-xl border border-[#E2E8F0]">
          <table className="w-full min-w-[520px] text-left text-sm">
            <thead>
              <tr className="border-b border-[#E2E8F0] bg-[#F8FAFC] text-xs uppercase tracking-wide text-[#64748B]">
                <th className="px-4 py-3 font-medium">Transaction ID</th>
                <th className="px-4 py-3 font-medium">Description</th>
                <th className="px-4 py-3 font-medium">Amount</th>
                <th className="px-4 py-3 font-medium">Currency</th>
                <th className="px-4 py-3 font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-[#F1F5F9] last:border-0">
                  <td className="px-4 py-3 font-mono text-xs font-medium text-[#1E3A6E]">{r.id}</td>
                  <td className="px-4 py-3 text-[#334155]">{r.desc}</td>
                  <td className="px-4 py-3 font-semibold text-[#0F172A]">{r.amount}</td>
                  <td className="px-4 py-3 text-[#64748B]">{r.ccy}</td>
                  <td className="px-4 py-3"><Badge status={r.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default DashboardMockup;
